// SpecialCategoryConfig.js
// Configuration for special category layouts and product display settings
//
// Usage:
//   Map category names to objects containing:
//     - enabled: boolean to enable special configuration
//     - productsPerPage: number of products to show per page (default: 4)
//     - layoutType: "expanded" or "default" (default: "default")
//     - prioritizedUpcs: array of UPCs to prioritize in this category

const specialCategoryConfig = {
  // Example configuration:
  // "Fresh Fruit": {
  //   enabled: true,
  //   productsPerPage: 8,
  //   layoutType: "expanded",
  //   prioritizedUpcs: ["0000000001234", "0000000005678"]
  // }
};

export default specialCategoryConfig;

